export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13836.3a405b7a.jpg";